// local stoarge keys
export const LS_KEY = {
  AUTH_INFO: "AUTH_INFO",
  // Portal: the keys firewalla.web reads. Written alongside AUTH_INFO so both
  // the classic per-instance frontend and the portal work during migration.
  ACCESS_TOKEN: "__ACCESS_TOKEN__",
  ID_TOKEN: "__ID_TOKEN__",
  REFRESH_TOKEN: "__REFRESH_TOKEN__",
  // A Cognito refresh token is bound to the app client that issued it, and this
  // page is the issuer. The SPA is the long-lived session and does the
  // refreshing, so it needs the client that minted the tokens -- never the
  // instance's own client, which cannot renew them.
  AUTH_CLIENT: "__AUTH_CLIENT__",
  AUTH_REGION: "__AUTH_REGION__",
  CLOSE_SIGNIN_TOOLTIP: "CLOSE_SIGNIN_TOOLTIP",
  LOGIN_SERVER: "LOGIN_SERVER",
}

// session storage keys
export const SS_KEY = {
  PATH_BEFORE_SIGNIN: "PATH_BEFORE_SIGNIN",
  SELECTED_PLAN_BEFORE_SIGNIN: "SELECTED_PLAN_BEFORE_SIGNIN",
}

export interface ISelectedPlanBeforeSignin {
  selected_at: number; // timestamp in milliseconds
  type: "personal" | "business";
  interval: "monthly" | "yearly";
}

export const LINKS = {
  LITE_MSP: {
    OFFICIAL: 'https://my.firewalla.net',
    DEV: 'https://t1.dd.firewalla.net',
  }
}